class UserService {
  isLoggedIn () {
    return !!localStorage.getItem('user')
  }

  logout () {
    localStorage.clear()
    window.location.reload()
  }

  getUser () {
    try {
      return JSON.parse(localStorage.getItem('user'))
    } catch (e) {
      return null
    }
  };

  setUser (user) {
    localStorage.setItem('user', JSON.stringify(user))
  };
}

export default new UserService()
